import { useMemo } from 'react';
import {
  StepName,
  type InternshipProcessWithNames,
} from '../../Types/interfaces';

export const useReadyToSignConventions = (
  internshipProcesses: Array<InternshipProcessWithNames>
) => {
  return useMemo(() => {
    return internshipProcesses.filter((process) =>
      process.processSteps.some(
        (step) =>
          step.stepName ===
            'SigningInternshipConventionByUniversitySupervisor' &&
          step.stepStatus === 1
      )
    );
  }, [internshipProcesses]);
};

export const useEvaluatedReports = (
  internshipProcesses: Array<InternshipProcessWithNames>
) => {
  return useMemo(() => {
    return internshipProcesses.filter(
      (process) =>
        process.processSteps.some(
          (step) =>
            step.stepName === 'CompletingEvaluationReportByOrganization' &&
            step.stepStatus === 3
        ) &&
        process.processSteps.some(
          (step) =>
            step.stepName === StepName.signingInternshipConventionByRector &&
            (step.stepStatus === 2 || step.stepStatus === 3)
        ) &&
        process.processSteps.some(
          (step) =>
            step.stepName === 'GradingWorkReportByUniversitySupervisor' &&
            step.stepStatus !== 3
        )
    );
  }, [internshipProcesses]);
};
